import React from 'react';

import {DataValidationProps} from '../DataValidation';
import './styles.scss';
import {addToWizard} from '../../../../../store/actions';
import {compose} from 'redux';
import {connect} from 'react-redux';
import SelectContact from './select-contact';
import EnterCode from './enter-code';

function ActivateRegistration(props: DataValidationProps) {
  const {wizard} = props;
  return wizard &&
    wizard.dataValidation &&
    !!wizard.dataValidation.selectedContact ? (
    <EnterCode {...props} />
  ) : (
    <SelectContact {...props} />
  );
}

const mapStateToProps = ({wizard, stringsDefault}: any) => ({
  wizard: wizard.value,
  labels: stringsDefault.value.pt.register,
});

const mapDispatchToProps = (dispatch: any) => ({
  addToWizard: (value: any) => dispatch(addToWizard(value)),
});

export default compose(
  connect(mapStateToProps, mapDispatchToProps)(ActivateRegistration)
);
